module.exports = __webpack_public_path__ + "static/media/techno-8.fccce133.png";